var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "basic",
    viewBox: "0 0 48 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 28l14-7 24 12-14 7z",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M21.5 30.8c-.7-.4-1.4-.4-1.9-.2l-1.4.7c-.5.2-.9.8-.9 1.6 0 1.5 1.3 3.4 2.8 4.2.8.4 1.5.4 2 .2 0 0 1.4-.7 1.5-.8.5-.3.7-.8.7-1.5 0-1.6-1.3-3.5-2.8-4.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 37.2c.2-.1 1.4-.7 1.5-.7.5-.3.7-.8.7-1.5 0-.6-.2-1.3-.5-1.9l-1.4.7c.3.6.5 1.3.5 1.9.1.7-.3 1.3-.8 1.5z",
    opacity: 0.39
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M22.1 35.3c0 1.2-.9 1.6-2.1 1-1.2-.6-2.1-2-2.1-3.2s.9-1.6 2.1-1c1.2.6 2.1 2 2.1 3.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#808285",
    d: "M20.2 36.3c-1.2-.6-2.1-2-2.1-3.2 0-.6.2-1 .6-1.2-.5.1-.8.6-.8 1.2 0 1.2.9 2.6 2.1 3.2.6.3 1.1.3 1.5.1-.3.2-.8.1-1.3-.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M21.1 34.6c0 .5-.4.7-.9.4s-.9-.8-.9-1.3.4-.7.9-.4.9.8.9 1.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1 34.6c0 .5-.4.7-.9.4s-.9-.8-.9-1.3.4-.7.9-.4.9.8.9 1.3z",
    opacity: 0.39
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M20.9 34.7c0 .5-.4.7-.9.4-.5-.2-.9-.8-.9-1.3s.4-.7.9-.4c.5.2.9.8.9 1.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9 35.7c0 1.5-1.3 2.2-2.8 1.4-1.5-.8-2.8-2.7-2.8-4.2s1.3-2.2 2.8-1.4c1.5.7 2.8 2.6 2.8 4.2z",
    opacity: 0.06
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M22.5 32.9v3.8l2.5-1.3v-3.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 32.9v3.8l2.5-1.3v-3.7z",
    opacity: 0.06
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M7.4 23.8c-.7-.4-1.4-.4-1.9-.2l-1.4.7c-.5.2-.9.8-.9 1.6 0 1.5 1.3 3.4 2.8 4.2.8.4 1.5.4 2 .2 0 0 1.4-.7 1.5-.8.5-.3.7-.8.7-1.5.1-1.6-1.2-3.5-2.8-4.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30.2c.2-.1 1.4-.7 1.5-.7.5-.3.7-.8.7-1.5 0-.6-.2-1.3-.5-1.9l-1.4.7c.3.6.5 1.3.5 1.9.1.7-.3 1.3-.8 1.5z",
    opacity: 0.39
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M8.1 28.3c0 1.2-.9 1.6-2.1 1s-2-1.9-2-3.1.9-1.6 2.1-1c1.1.5 2 1.9 2 3.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#808285",
    d: "M6.2 29.3c-1.2-.6-2.1-2-2.1-3.2 0-.6.2-1 .6-1.2-.4.2-.7.6-.7 1.3 0 1.2.9 2.6 2.1 3.2.6.3 1.1.3 1.5.1-.4.1-.9 0-1.4-.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M7.1 27.6c0 .5-.4.7-.9.4s-.9-.8-.9-1.3.4-.7.9-.4.9.8.9 1.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1 27.6c0 .5-.4.7-.9.4s-.9-.8-.9-1.3.4-.7.9-.4.9.8.9 1.3z",
    opacity: 0.39
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M6.9 27.7c0 .5-.4.7-.9.4s-.9-.8-.9-1.3.4-.7.9-.4.9.8.9 1.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 28.7c0 1.5-1.3 2.2-2.8 1.4-1.5-.8-2.8-2.7-2.8-4.2s1.3-2.2 2.8-1.4c1.5.7 2.8 2.6 2.8 4.2z",
    opacity: 0.06
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M8.5 25.9v3.8l2.5-1.3v-3.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 25.9v3.8l2.5-1.3v-3.7z",
    opacity: 0.06
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3134",
    d: "M40 26v2l-14 7v-2zM2 21v2l24 12v-2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#28896D",
    d: "M16 6L2 13v8l24 12 14-7v-8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22l-14-7V7l22 11z",
    opacity: 0.06
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17l4-2V7L4 13z",
    opacity: 0.39
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26 35L2 23V13l24 12z",
    opacity: 0.06
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M40 18l-14 7v10l14-7z",
    opacity: 0.39
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#28896D",
    d: "M16 6L2 13l24 12 14-7L16 6zm10 18L4 13l12-6 22 11-12 6z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12 17l14 7 4-2-14-7z",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#28896D",
    d: "M36 28l-6 3v1l14 5 2-1v-1l-10-7zm-2.8 3.4L36 30l5.6 4.2-8.4-2.8z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#28896D",
    d: "M36 30l8 6v-1l-8-6-4 2v1z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M30 31v1l14 5v-1z",
    opacity: 0.06
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M44 37l2-1v-1l-2 1z",
    opacity: 0.39
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M36 30l5.6 4.2 2.4.8-8-6z",
    opacity: 0.06
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31l1.2.4L36 30v-1z",
    opacity: 0.39
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenTop);
export default __webpack_public_path__ + "static/media/openTop.22f8227c1de190c85bada10e43d51f02.svg";
export { ForwardRef as ReactComponent };